import { useUser } from "@/context/useUser";
import { getAccessToken } from "@lib/storeManager";
import navigationRoutes from "@/utils/navigationRoutes";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRouter = () => {
  const { isAuthenticated } = useUser();
  const isLoggedIn = getAccessToken() !== null;

  return isAuthenticated || isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to={navigationRoutes.LOGIN} />
  );
};

export default ProtectedRouter;
